import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { QuoteFilterOptions, SortType, SortTypes } from '~/lib/quotes';
import FilterDropDown from './quote-filter-dropdown';
import { useMemo } from 'react';

export default function SortBy({
  filter,
  onChange,
  label,
  dataTestId
}: {
  dataTestId?: string;
  label?: string;
  filter: QuoteFilterOptions;
  onChange: (filter: QuoteFilterOptions) => void;
}) {
  const { t } = useTranslation([TranslationNamespaces.QUOTE]);

  const listSortTypes = useMemo(() => {
    if (filter.serviceType === 'SameDay') return SortTypes.filter((x) => x !== 'Fastest');

    if (filter.serviceType === 'Collection') return SortTypes.filter((x) => x !== 'Closest');

    return SortTypes;
  }, [filter.serviceType]);

  return (
    <FilterDropDown
      dataTestId={dataTestId}
      options={listSortTypes.map((s) => ({
        key: s as string,
        value: s as string,
        text: t(`FILTER_SORT_TYPE_OPTION_${s}`, { defaultValue: s })
      }))}
      selected={filter.sortType}
      label={label}
      onChange={(v) =>
        onChange({
          ...filter,
          sortType: filter.sortType === (v as SortType) ? undefined : (v as SortType)
        })
      }
    />
  );
}
